import { useSelector } from "react-redux";
import { getUserUidSelector } from "../../app/appSelectors";
import { useCallback } from "react";
import { setLocalStorageItem } from "../../utils/storage/setLocalStorageItem";
import { getLocalStorageItem } from "../../utils/storage/getLocalStorageItem";
import { removeStorageItem } from "../../utils/storage/removeStorageItem";

function useUserStorage() {
    const userUid = useSelector(getUserUidSelector);
    const storageKey = `user${userUid}`;

    const setUserStorageItem = useCallback((name, value) => {
        setLocalStorageItem(storageKey, name, value);
    }, [storageKey]);

    const removeUserStorageItem = useCallback((name) => {
        removeStorageItem(storageKey, name);
    }, [storageKey])

    const getUserStorageItem = useCallback((name, def = undefined) => {
        return getLocalStorageItem(storageKey, name, def)
    }, [storageKey]);

    return {
        getUserStorageItem,
        removeUserStorageItem,
        setUserStorageItem,
    };
}

export default useUserStorage;
